import { render, staticRenderFns } from "./cartBottomNav.vue?vue&type=template&id=023d60c3&scoped=true"
import script from "./cartBottomNav.vue?vue&type=script&lang=js"
export * from "./cartBottomNav.vue?vue&type=script&lang=js"
import style0 from "./cartBottomNav.vue?vue&type=style&index=0&id=023d60c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d60c3",
  null
  
)

export default component.exports